export default function authHeader() {
    let user = localStorage.getItem('access_token');

    if (user) {
      return {
        Authorization: "Bearer " + user,
        Accept: "application/json",
        "Content-Type": "application/json",
      };
    } else {
      return {};
    }
  }